import { foldSearchText } from '@till-erp/platform/lists';

/**
 * Text für die Suche: klein, ß → ss, ohne Akzente/Umlaut-Punkte (Rudolf 05.10.2026: Suchfeld über jeder Tabelle).
 * Erst klein schreiben, damit auch das große ẞ zu ß und dann zu ss wird.
 */
export function searchText(text: string): string {
  // Dieselbe Such-Faltung wie die Listen (platform `foldSearchText`: ä = a = ae, ß = ss, Rudolf 05.10.), danach übrige
  // Akzente (é, ñ …) weg.
  return foldSearchText(text.toLowerCase()).normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

/** Passt eine Zeile (ihre sichtbaren Texte) zur Suche? Jedes Wort der Suche muss irgendwo vorkommen; leer = alles. */
export function matchesSearch(texts: readonly string[], query: string): boolean {
  const words = searchText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = searchText(texts.join(' '));
  return words.every((w) => haystack.includes(w));
}
